module.exports = __webpack_public_path__ + "pc/img/rec_15.66aa3714.svg";